// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"3fb38d0a","453":"99798bf3","717":"e19846f7"}[chunkId] + ".chunk.js";
};